import { observable } from 'mobx';

export type SegmentTerminalResponseArgs = {
  name: string;
  short_time: string;
  time: string;
};

export type SegmentTerminalArgs = {
  name: string;
  shortTime: string;
  time: string;
};

export const convertSegmentTerminalResponseToArgs = (response: SegmentTerminalResponseArgs) => {
  const args: SegmentTerminalArgs = {
    name: response.name,
    shortTime: response.short_time,
    time: response.time
  };
  return args;
};

export default class SegmentTerminal {
  @observable name: string;
  @observable shortTime: string;
  @observable time: string;

  constructor(args: SegmentTerminalArgs) {
    this.name = args.name;
    this.shortTime = args.shortTime;
    this.time = args.time;
  }
}
